import { StateShape } from "../reducers";

export const confirmationModalData = (state: StateShape) => state.confirmationModal;
